"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDCert = void 0;
var pstruct_1 = require("../../../PTypes/PStruct/pstruct.js");
var types_1 = require("../../../type_system/types.js");
var PStakingCredential_1 = require("../Address/PStakingCredential.js");
var PPubKeyHash_1 = require("../PubKey/PPubKeyHash.js");
exports.PDCert = (0, pstruct_1.pstruct)({
    KeyRegistration: { stakeKey: PStakingCredential_1.PStakingCredential.type },
    KeyDeRegistration: { stakeKey: PStakingCredential_1.PStakingCredential.type },
    KeyDelegation: {
        delegator: PStakingCredential_1.PStakingCredential.type,
        poolKeyHash: PPubKeyHash_1.PPubKeyHash.type
    },
    PoolRegistration: {
        poolId: PPubKeyHash_1.PPubKeyHash.type,
        poolVRF: PPubKeyHash_1.PPubKeyHash.type,
    },
    PoolRetire: {
        poolId: PPubKeyHash_1.PPubKeyHash.type,
        epoch: types_1.int, // epoch
    },
    Genesis: {},
    MoveInstantRewards: {}
});
